/* TODO(ASIMO-2105): cherrera2@ to remove once experiment is over regardless of outcome */
import React, { useCallback } from 'react';

import { AnalyticsListener, type UIAnalyticsEvent } from '@atlaskit/analytics-next';

const THIRD_PARTY_SUBJECT = 'thirdPartyOAuth';

export const ANALYTICS_CHANNEL = 'media';
export const COMPONENT_NAME = 'linkPicker';

export enum ThirdPartyAuthSource {
	CONNECT_BANNER = 'connect-banner',
	EMPTY_STATE_CTA = 'empty-state-cta',
}

interface ThirdPartyAuthFlowAnalyticsPayload {
	action: 'clicked' | 'completed' | 'failed';
	actionSubject: string;
	attributes: {
		oAuthSource: ThirdPartyAuthSource;
		tab: string;
	};
	eventType: 'ui' | 'track';
}

export const buildAuthClickedEventPayload = (
	authSource: ThirdPartyAuthSource,
	tab: string,
): ThirdPartyAuthFlowAnalyticsPayload => ({
	action: 'clicked',
	eventType: 'ui',
	actionSubject: THIRD_PARTY_SUBJECT,
	attributes: {
		tab,
		oAuthSource: authSource,
	},
});

export const buildAuthCompletedEventPayload = (
	authSource: ThirdPartyAuthSource,
	tab: string,
): ThirdPartyAuthFlowAnalyticsPayload => ({
	action: 'completed',
	eventType: 'track',
	actionSubject: THIRD_PARTY_SUBJECT,
	attributes: {
		tab,
		oAuthSource: authSource,
	},
});

export const buildAuthFailedEventPayload = (
	authSource: ThirdPartyAuthSource,
	tab: string,
): ThirdPartyAuthFlowAnalyticsPayload => ({
	action: 'failed',
	eventType: 'track',
	actionSubject: THIRD_PARTY_SUBJECT,
	attributes: {
		tab,
		oAuthSource: authSource,
	},
});

export function withAnalyticsContext<P extends Record<string, any>>(
	WrappedComponent: React.ComponentType<P>,
): React.ComponentType<P> {
	return (props: P) => {
		const onEvent = useCallback((event: UIAnalyticsEvent) => {
			event.update({
				attributes: {
					...(event.payload.attributes ?? {}),
				},
			});
		}, []);
		return (
			<AnalyticsListener channel={ANALYTICS_CHANNEL} onEvent={onEvent}>
				<WrappedComponent {...props} />
			</AnalyticsListener>
		);
	};
}
